import React, { Component } from "react";
import SectionFooter from "./sectionfooter";

class Chronik extends Component {
  render() {
    return (
      <section id="chronik">
        <h1>Chronik</h1>
        <div className="no-bottom-margin">
          <object
            data={require("../pdf/Festschriftzum100jaehrigenJubilaeumfuerChronik.pdf")}
            type="application/pdf"
            className="object-style"
          >
            <embed
              src={require("../pdf/Festschriftzum100jaehrigenJubilaeumfuerChronik.pdf")}
              type="application/pdf"
            />
          </object>
        </div>
        <SectionFooter />
      </section>
    );
  }
}
export default Chronik;



// WEBPACK FOOTER //
// ./src/components/chronik.js